<template>
  <div v-bind:class="[['col-sm-'+sm, 'col-md-'+md, 'col-lg-'+lg],{'multipleMovile' : windowSize<992}]" v-if="createdCycle && newDataMultiple().length>0"> 
    <table style="width:100%" class="table--multiple">
      <thead>
        <tr>
          <th v-for="(items,index) in views" :key="'th'+index">{{items.th}}</th>
        </tr>
      </thead>
      <tbody v-if="readonly===false">
        <tr v-for="(items,index) in newDataMultiple()" :key="'tr1'+index">
          <td v-for="(items2,index2) in views" :key="'td1'+index2"  :class="classTd">
              <div v-if="items2.group" :style=" !items.name_list ? 'margin-top: -42px' : ''">
                  <span>{{items[items2.td]}} </span>
                  <validation-provider 
                  v-if="items.name_list!=='' &&  items.name_list!==null && items2.list===undefined" 
                  immediate :rules="datadb[getTable].id_list.validate" v-slot="{ errors }" style="position:relative">
                  <c-multiselect 
                    :style="items2.style"  
                    class="open-width"
                    v-bind:class="{'border-danger': isDangerClass(items.check,items.name,items.id_list)}"
                    :id="getTable+items.id_list+'td1'+index"
                    :name="getTable+items.id_list+'td1'+index"
                    :placeholder="datadb[getTable].id_list.placeholder"
                    v-model="items.id_list"
                    :options="lists[items.name_list]"
                    :label="datadb[getTable].id_list.datatype.label"
                    :disabled="datadb[getTable].id_list.datatype.disabled"
                    :allow-empty="false"
                    >									 
                  </c-multiselect> 
                  <small class="text-danger select-errors">{{errors[0]}}</small>
                </validation-provider> 
              </div>
              <div v-else>
                <b-form-checkbox
                  :style="items2.style"
                  v-if="datadb[getTable][items2.td].datatype.type==='check'"
                  size="lg"
                  :id="getTable+items2.td+'td1'+index"
                  v-model="items[items2.td]"
                  :name="getTable+items2.td+'td1'+index"
                  :disabled="items.disabled===1"
                  :value="1"
                  :unchecked-value="0"
                  >
                </b-form-checkbox>
                
                
                <span  :style="items2.style" v-if="datadb[getTable][items2.td].datatype.type==='span' || datadb[getTable][items2.td].datatype.type==='input'">
                  <span v-if="items[items2.td]==='Riesgo'">{{gettersDatalist('list_arl',gettersDatalist('datos_razon',dataForm[namePath].info_afiliacion.id_datos_razon)[0].id_list_arl)[0].name}}</span>
                  {{items[items2.td]}} 
                </span>   
                
                <validation-provider 
                  v-if="datadb[getTable][items2.td].datatype.type==='select' && items.name_list!=='' &&  items.name_list!==null && items2.list===undefined" 
                  immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">
                  <c-multiselect 
                    :style="items2.style"  
                    class="open-width"
                    v-bind:class="{'border-danger': isDangerClass(items.check,items.name,items.id_list)}"
                    :id="getTable+items2.td+'td1'+index"
                    :name="getTable+items2.td+'td1'+index"
                    :placeholder="datadb[getTable][items2.td].placeholder"
                    v-model="items[items2.td]"
                    :options="lists[items.name_list]"
                    :label="datadb[getTable][items2.td].datatype.label"
                    :disabled="datadb[getTable][items2.td].datatype.disabled"
                    :allow-empty="false"
                    >									 
                  </c-multiselect> 
                  <small class="text-danger select-errors">{{errors[0]}}</small>
                </validation-provider> 
                
                <validation-provider 
                  v-if="datadb[getTable][items2.td].datatype.type==='select' && items.name_list!=='' &&  items.name_list!==null && items2.list!==undefined && items[items2.td]!==null" 
                  immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">
                  <c-multiselect   
                    :style="items2.style"  
                    class="open-width"         
                    v-bind:class="{'border-danger': isDangerClass(items.check,items.name,items.id_list)}"
                    :id="getTable+items2.td+'td1'+index"
                    :name="getTable+items2.td+'td1'+index"
                    :placeholder="datadb[getTable][items2.td].placeholder"
                    v-model="items[items2.td]"
                    :options="lists[items2.list]"
                    :label="datadb[getTable][items2.td].datatype.label"
                    :disabled="datadb[getTable][items2.td].datatype.disabled"
                    :allow-empty="false"
                    >									 
                  </c-multiselect> 
                  <small class="text-danger select-errors">{{errors[0]}}</small>
                </validation-provider> 
                
                <b-input-group  
                v-if="datadb[getTable][items2.td].datatype.type==='price' && items2.td"              
                  size="sm">   
                  <validation-provider immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">     
                    <vue-numeric 
                      :style="items2.style"
                      currency="$"
                      v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[getTable][items2.td].validate,items[items2.td])===false}"
                      separator="."   
                      class="form-control"  
                      :empty-value="datadb[getTable][items2.td].datatype.predeterminate"
                      :id="getTable+items2.td+'td1'+index"
                      :name="getTable+items2.td+'td1'+index"
                      v-model="items[items2.td]"
                      :precision="datadb[getTable][items2.td].datatype.precision"
                      :read-only="datadb[getTable][items2.td].datatype.readonly"
                      :read-only-class="datadb[getTable][items2.td].datatype.readonlyclass"
                      :disabled="datadb[getTable][items2.td].datatype.disabled"
                      @change="changeInput(datadb[getTable][items2.td].id)"
                      @input="inputInput(datadb[getTable][items2.td].id);"
                      @update="updateInput(datadb[getTable][items2.td].id)"
                      @blur="blurInput(datadb[getTable][items2.td].id)" >
                    </vue-numeric>   
                    <small class="text-danger input-errors">{{errors[0]}}</small>
                  </validation-provider>      
                </b-input-group>  
                
                <validation-provider  
                v-if="datadb[getTable][items2.td].datatype.type==='file'" 
                    immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">  
                  <b-form-file 
                    :style="items2.style"
                    :id="getTable+items2.td+'td1'+index"
                    :name="getTable+items2.td+'td1'+index"
                    size="sm"
                    v-model="items[items2.td]"
                    :state="veevalidateInputs(errors[0],datadb[getTable][items2.td].validate,items[items2.td])"
                    placeholder="Seleccionar archivo pdf"
                    drop-placeholder="Buscar archivo aquí"
                    browse-text="Buscar"
                  ></b-form-file>
                  <small  class="text-danger file-errors">{{errors[0]}}</small>
                </validation-provider>   
                
                <validation-provider
                  v-if="datadb[getTable][items2.td].datatype.type==='date' && items.check===1 && items.name!=='Administración'" 
                  immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">  
                  <input 
                      :style="items2.style"
                      v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[getTable][items2.td].validate,items[items2.td])===false}" 
                      :id="getTable+items2.td+'td1'+index"
                      :name="getTable+items2.td+'td1'+index"
                      :disabled="datadb[getTable][items2.td].datatype.disabled"
                      class="input-date" 
                      type="date"  
                      v-model="items[items2.td]">      
                  <small  class="text-danger file-errors">{{errors[0]}}</small>
                </validation-provider> 
              </div>
          </td>
        </tr>
        <tr v-if="total">
          <td  v-for="(items,index) in views" :key="'th2'+index" style="padding: 4px 0">
            <span v-if="items.th==='Afiliación'" style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
              <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0" currency="$" disabled class="form-control" separator="." v-model="totalAfiliacion" ></vue-numeric>
                    <b-input-group-append>
                      <b-button style="padding: 0px;margin-left:-10px"  @click="aproximarAfiliacion(1000,totalAfiliacion,1)" size="sm" variant="outline-success"><b-icon icon="arrow-bar-up"></b-icon></b-button>
                      <b-button  style="padding: 0px"  @click="aproximarAfiliacion(1000,totalAfiliacion,0)" size="sm" variant="outline-danger"><b-icon icon="arrow-bar-down"></b-icon></b-button>                                   
                    </b-input-group-append>
                  </b-input-group>
            </span>
            <span v-if="items.td==='valoringreso' && dataForm[namePath].info_afiliacion.id_list_novedad===1"  style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
                  <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0"   currency="$" disabled class="form-control" separator="." v-model="totalValorIngreso" ></vue-numeric>
                    <b-input-group-append>
                      <b-button style="padding: 0px;margin-left:-10px"  @click="aproximarIngreso(1000,totalValorIngreso,1)" size="sm" variant="outline-success"><b-icon icon="arrow-bar-up"></b-icon></b-button>
                      <b-button  style="padding: 0px"  @click="aproximarIngreso(1000,totalValorIngreso,0)" size="sm" variant="outline-danger"><b-icon icon="arrow-bar-down"></b-icon></b-button>                                   
                    </b-input-group-append>
                  </b-input-group>
            </span>
          <span v-if="items.td==='valor'"  style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
                  <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0"   currency="$" disabled class="form-control" separator="." v-model="totalValor" ></vue-numeric>
                    <b-input-group-append>
                      <b-button style="padding: 0px;margin-left:-10px"  @click="aproximarValor(1000,totalValor,1)" size="sm" variant="outline-success"><b-icon icon="arrow-bar-up"></b-icon></b-button>
                      <b-button  style="padding: 0px"  @click="aproximarValor(1000,totalValor,0)" size="sm" variant="outline-danger"><b-icon icon="arrow-bar-down"></b-icon></b-button>                                   
                    </b-input-group-append>
                  </b-input-group>
            </span>
            <span v-if="items.td==='valorretiro' && dataForm[namePath].info_afiliacion.id_list_novedad===3"  style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
                  <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0"   currency="$" disabled class="form-control" separator="." v-model="totalValorRetiro" ></vue-numeric>
                    <b-input-group-append>
                      <b-button style="padding: 0px;margin-left:-10px"  @click="aproximarRetiro(1000,totalValorRetiro,1)" size="sm" variant="outline-success"><b-icon icon="arrow-bar-up"></b-icon></b-button>
                      <b-button  style="padding: 0px"  @click="aproximarRetiro(1000,totalValorRetiro,0)" size="sm" variant="outline-danger"><b-icon icon="arrow-bar-down"></b-icon></b-button>                                   
                    </b-input-group-append>
                  </b-input-group>
            </span>
          </td>
        </tr>
      </tbody>
      <tbody v-if="readonly===true">
        <tr v-for="(items,index) in newDataMultiple()" :key="'tr2'+index"> 
          <td v-for="(items2,index2) in views" :key="'td2'+index2">
            
            <b-form-checkbox
                v-if="datadb[getTable][items2.td].datatype.type==='check'"
                size="lg"
                :id="getTable+items2.td+'td1'+index"
                v-model="items[items2.td]"
                :name="getTable+items2.td+'td1'+index"
                :disabled="true"
                :value="1"
                :unchecked-value="0"
              >
            </b-form-checkbox>

            <span v-if="datadb[getTable][items2.td].datatype.type==='span' || datadb[getTable][items2.td].datatype.type==='input'">{{items[items2.td]}}</span>   

            <validation-provider 
            v-if="datadb[getTable][items2.td].datatype.type==='select' && items.name_list!=='' &&  items.name_list!==null && items2.list===undefined" 
              immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">
              <c-multiselect   
                :style="items2.style"  
                v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[getTable][items2.td].validate,items[items2.td])===false}"
                class="open-width"
                :id="getTable+items2.td+'td1'+index"
                :name="getTable+items2.td+'td1'+index"
                :placeholder="datadb[getTable][items2.td].placeholder"
                v-model="items[items2.td]"
                :options="lists[items.name_list]"
                :label="datadb[getTable][items2.td].datatype.label"
                :disabled="items2.disabled || items.name==='Riesgo'"
                :allow-empty="false"
                >									 
              </c-multiselect> 
              <small class="text-danger select-errors">{{errors[0]}}</small>
            </validation-provider> 

            <validation-provider 
            v-if="datadb[getTable][items2.td].datatype.type==='select' && items.name_list!=='' &&  items.name_list!==null && items2.list!==undefined" 
              immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">
              <c-multiselect   
                  :style="items2.style"  
                v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[getTable][items2.td].validate,items[items2.td])===false}"
                class="open-width"
                :id="getTable+items2.td+'td1'+index"
                :name="getTable+items2.td+'td1'+index"
                :placeholder="datadb[getTable][items2.td].placeholder"
                v-model="items[items2.td]"
                :options="lists[items2.list]"
                :label="datadb[getTable][items2.td].datatype.label"
                :allow-empty="false"
                :disabled="items2.disabled || items.name==='Riesgo'"
                >									 
              </c-multiselect> 
              <small class="text-danger select-errors">{{errors[0]}}</small>
            </validation-provider> 

            <b-input-group  
            v-if="datadb[getTable][items2.td].datatype.type==='price'"              
              size="sm">   
              <validation-provider immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">     
                <vue-numeric 
                  currency="$"
                  v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[getTable][items2.td].validate,items[items2.td])===false}"
                  separator="."   
                  class="form-control"   
                  :empty-value="datadb[getTable][items2.td].datatype.predeterminate"   
                  :id="getTable+items2.td+'td1'+index"
                  :name="getTable+items2.td+'td1'+index"
                  v-model="items[items2.td]"
                  :precision="datadb[getTable][items2.td].datatype.precision"
                  :read-only="datadb[getTable][items2.td].datatype.readonly"
                  :read-only-class="datadb[getTable][items2.td].datatype.readonlyclass"
                  :disabled="true"
                  @change="changeInput(datadb[getTable][items2.td].id)"
                  @input="inputInput(datadb[getTable][items2.td].id);"
                  @update="updateInput(datadb[getTable][items2.td].id)"
                  @blur="blurInput(datadb[getTable][items2.td].id)" >
                </vue-numeric>   
                <small class="text-danger input-errors">{{errors[0]}}</small>
              </validation-provider>      
            </b-input-group>  

            <validation-provider  
                v-if="datadb[getTable][items2.td].datatype.type==='file'" 
                immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">  
              <b-form-file 
                :id="getTable+items2.td+'td1'+index"
                :name="getTable+items2.td+'td1'+index"
                size="sm"
                v-model="items[items2.td]"
                :state="veevalidateInputs(errors[0],datadb[getTable][items2.td].validate,items[items2.td])"
                placeholder="Seleccionar archivo pdf"
                drop-placeholder="Buscar archivo aquí"
                browse-text="Buscar"
              ></b-form-file>
              <small  class="text-danger file-errors">{{errors[0]}}</small>
            </validation-provider>   

            <validation-provider
            v-if="datadb[getTable][items2.td].datatype.type==='date'" 
              immediate :rules="datadb[getTable][items2.td].validate" v-slot="{ errors }" style="position:relative">  
              <input 
                  v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[getTable][items2.td].validate,items[items2.td])===false}" 
                  :id="getTable+items2.td+'td1'+index"
                  :name="getTable+items2.td+'td1'+index"
                  :disabled="true"
                  class="input-date" 
                  type="date"  
                  v-model="items[items2.td]">      
              <small  class="text-danger file-errors">{{errors[0]}}</small>
            </validation-provider> 

          </td>
        </tr>   
        <tr v-if="total">
          <td  v-for="(items,index) in views" :key="'th2'+index" style="padding: 4px 0">
            <span v-if="items.th==='Afiliación'" style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
              <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0" currency="$" disabled class="form-control" separator="." v-model="totalAfiliacion" ></vue-numeric>
                  </b-input-group>
            </span>
          <span v-if="(items.th==='1r Aporte' || items.th==='Valor') && dataForm[namePath].info_afiliacion.id_list_novedad===1"  style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
                  <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0"   currency="$" disabled class="form-control" separator="." v-model="totalValorIngreso" ></vue-numeric>
                  </b-input-group>
            </span>
          <span v-if="items.th==='Valor' && dataForm[namePath].info_afiliacion.id_list_novedad===2"  style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
                  <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0"   currency="$" disabled class="form-control" separator="." v-model="totalValor" ></vue-numeric>
                  </b-input-group>
            </span>
          <span v-if="items.th==='Valor' && dataForm[namePath].info_afiliacion.id_list_novedad===3"  style="border-top:2px solid rgba(85, 85, 85, .8);min-width:104px;display:block;padding-top:15px"> 
                  <b-input-group>
                    <vue-numeric style="font-weight:bold;padding:0" :empty-value="0"   currency="$" disabled class="form-control" separator="." v-model="totalValorRetiro" ></vue-numeric>
                  </b-input-group>
            </span>
          </td>
        </tr>   
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from 'moment'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
import Multiselect  from '@/components/vue-multiselect/src/';
import { ValidationProvider } from 'vee-validate';
import '../../mixings/validate.js';
import {deepCopy} from '@/stores/functions/functions.js';
export default 
{
  name: 'swmultiples',
  props: { 
    hideServicio: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    views: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    getTable: {
      type: String,
      default: ''
    },
    sm : {
      type: Number,
      default: 12
    },
    md : {
      type: Number,
      default: 12
    },
    lg : {
      type: Number,
      default: 12
    },
    render: {
      type: Number,
      default: 0
    },
    comparar: {
      type: Array,
      default: function()
      {
        []
      }
    },
    total: {
      type: Boolean,
      default: true
    } ,
    classTd: {
      type: String
    } 
  },
  data(){
    return {
      firstMultiple: [],
      creado:0,
      updateMultiple: 0, 
      newPostTable: [],   
      postTable: '',
      createdCycle:false,
      totalAfiliacion: 0,
      totalValor: 0,
      totalValorIngreso: 0,
      totalValorRetiro: 0,
      ultimoChek: 0,
      ultimoRiesgo: 1,
      espejoMultiple: {
      },
      preciosMultiple:[],
      diasValorUltime: 30,
      diasAflUltime: 30,
      aportesUltime: 0,
      aproximar: false,
      aflAdmin:0,
      ultimoAdmin:0,
      ultimoAdminIngreso:0,
      ultimoAdminRetiro:0,
      totalActivos: 0,
      novedad: null,
      preciosInits: []
    }
  },
  async created()
  {    
    try {
      this.novedad=this.dataForm[this.namePath].info_afiliacion.id_list_novedad
      await this.updateDataForm({state: 'precios', data: await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1}) })
      this.preciosMultiple= await this.deepCopy(this.predeterminados[this.namePath][this.getTable])
      this.createdCycle=true 
    }catch(e)
    {
      console.log('warning dataMultiple',e)
    }
     
  },
  async updated()
  {
    try 
    {
      if(this.dataForm[this.namePath].precios===undefined ||  this.dataForm[this.namePath].precios.length===0)
      { 
        let precios = await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1})
        await this.updateDataForm({state: 'precios', data: precios})
      }
      
    } catch(e) {
      console.log(e)
    }
  },
  components: {
    'c-multiselect': Multiselect,
    VueNumeric,
    ValidationProvider
  },
  computed:
  {     
  },
  methods: {   
      isDangerClass(check,name,list)
      {
        if((name==='Eps' || name==='Ccf' || name==='Afp' || name==='Traslado') && check===1)
        {
          let value= _.filter(this.predeterminados[this.namePath][this.getTable], {'name':name, 'id_list': list})          
          return value.length>0
        }
        return false
      },
      aproximarRetiro(aprox,valor,tipo)
      { 
        this.aproximar=true
        let sobrante = this.redondeaValue(aprox,valor,tipo)

        let indexAdmin = this.dataMultiple[this.namePath][this.getTable].findIndex(list => list.name==='Administración')

        if((sobrante<0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].valorretiro+sobrante>0) || (sobrante>0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].valorretiro+sobrante>=0) )
        {
          this.dataMultiple[this.namePath][this.getTable][indexAdmin].valorretiro=this.dataMultiple[this.namePath][this.getTable][indexAdmin].valorretiro+sobrante
        }  
        
        return true

      },
      aproximarIngreso(aprox,valor,tipo)
      { 
        this.aproximar=true
        let sobrante = this.redondeaValue(aprox,valor,tipo)

        let indexAdmin = this.dataMultiple[this.namePath][this.getTable].findIndex(list => list.name==='Administración')

        
        if((sobrante<0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].valoringreso+sobrante>0) || (sobrante>0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].valoringreso+sobrante>=0) )
        {
          this.dataMultiple[this.namePath][this.getTable][indexAdmin].valoringreso=this.dataMultiple[this.namePath][this.getTable][indexAdmin].valoringreso+sobrante
        }  
        
        return true

      },  
      aproximarValor(aprox,valor,tipo)
      { 
        this.aproximar=true
        let sobrante = this.redondeaValue(aprox,valor,tipo)

        let indexAdmin = this.dataMultiple[this.namePath][this.getTable].findIndex(list => list.name==='Administración')

        if((sobrante<0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].valor+sobrante>0) || (sobrante>0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].valor+sobrante>=0) )
        {
          this.dataMultiple[this.namePath][this.getTable][indexAdmin].valor=this.dataMultiple[this.namePath][this.getTable][indexAdmin].valor+sobrante
        }  
        
        return true

      },     
      aproximarAfiliacion(aprox,valor,tipo)
      {
        let sobrante = this.redondeaValue(aprox,valor,tipo)
        
        let indexAdmin = this.dataMultiple[this.namePath][this.getTable].findIndex(list => list.name==='Administración')
        
        if((sobrante<0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].afiliacion+sobrante>=0) || (sobrante>0 && this.dataMultiple[this.namePath][this.getTable][indexAdmin].afiliacion+sobrante>=0) )
        {
          this.dataMultiple[this.namePath][this.getTable][indexAdmin].afiliacion=this.dataMultiple[this.namePath][this.getTable][indexAdmin].afiliacion+sobrante
        }
        
        return true

      },  
      totalAfiliacionFtn()
      {
        let sumdatapost
        let totalTotal=0
        let totalMin=0
        let index

        for(let i=0; i<this.dataMultiple[this.namePath][this.getTable].length; i++)
        {
            sumdatapost=this.dataMultiple[this.namePath][this.getTable][i]
            if(sumdatapost.check===1 && sumdatapost.name==='Administración')
            {
              totalTotal=parseInt(sumdatapost.afiliacion)+totalTotal 
            }  
            if(sumdatapost.check===1 && sumdatapost.name!=='Administración')
            {
              totalMin=parseInt(sumdatapost.afiliacion)+totalMin 
            } 
            if(sumdatapost.name==='Administración')
            {
              index=i
            }
        }
        
        if(totalMin>0)
          {
          if(this.totalAfiliacion<=totalMin)
          {
            this.totalAfiliacion=totalMin+this.redondeaValue(1000, totalMin, 1)
            this.dataMultiple[this.namePath][this.getTable][index].afiliacion=0
            totalTotal=this.totalAfiliacion-totalMin
          }
          else 
          {          
            totalTotal=this.totalAfiliacion-totalTotal
          }
          this.dataMultiple[this.namePath][this.getTable][index].afiliacion=this.dataMultiple[this.namePath][this.getTable][index].afiliacion+totalTotal
        }
        return true
      },     
      totalValorFtn()
      {
        let sumdatapost
        let totalTotal=0
        let totalMin=0
        let index

        for(let i=0; i<this.dataMultiple[this.namePath][this.getTable].length; i++)
        {
            sumdatapost=this.dataMultiple[this.namePath][this.getTable][i]
            if(sumdatapost.check===1)
            {
              totalTotal=parseInt(sumdatapost.valor)+totalTotal 
            }  
            if(sumdatapost.check===1 && sumdatapost.name!=='Administración')
            {
              totalMin=parseInt(sumdatapost.valor)+totalMin 
            } 
            if(sumdatapost.name==='Administración')
            {
              index=i
            }
        }
        if(totalMin>0)
        {
          if(this.totalValor<=totalMin)
          {
            this.totalValor=totalMin+this.redondeaValue(1000, totalMin, 1)
            this.dataMultiple[this.namePath][this.getTable][index].valor=0
            totalTotal=this.totalValor-totalMin
          }
          else 
          {          
            totalTotal=this.totalValor-totalTotal
          }
          this.dataMultiple[this.namePath][this.getTable][index].valor=this.dataMultiple[this.namePath][this.getTable][index].valor+totalTotal

        }        

        return true
      },     
      newDataMultiple()
      {  
        try {
          // saco los diasValor
            let diasValor=30
            if(this.dataForm[this.namePath].info_afiliacion.ingreso!==null && this.dataForm[this.namePath].info_afiliacion.ingreso!=='')
            {
              if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
              {
                diasValor= parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD'))
                if(diasValor>30)
                {
                  diasValor=30
                }
                diasValor=31-diasValor
              }
              if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
              {                
                let anoingreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('YYYY'))
                let mesingreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('MM'))
                let mesretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('MM'))
                let anoretiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('YYYY'))
                if(anoingreso===anoretiro && mesretiro==mesingreso)
                {
                  let fecha1=moment(this.dataForm[this.namePath].info_afiliacion.ingreso)
                  let fecha2=moment(this.dataForm[this.namePath].info_afiliacion.retiro)
                  diasValor=parseInt(fecha2.diff(fecha1, 'days'))+1
                
                  if(diasValor<=0)
                  {
                    diasValor=1
                    this.dataForm[this.namePath].info_afiliacion.retiro=this.dataForm[this.namePath].info_afiliacion.ingreso
                  }
                }
                else 
                {
                  diasValor=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('DD'))
                }
              }           
            }            
          // saco el nombre de la tabla para manipular ejem: servicios 
            this.postTable= this.getTable.split('_')[1]  

          // declaro las variables a usar en la funcion 
            let dataInits = {}
            let newNewDataMultiple = []  
            let comprarNamecheck = -1 
            let arlRiesgo = 1
            let totalNewValor=0
            let totalNewValorIngreso=0
            let totalNewValorRetiro=0
            let totalNewAfiliacion=0
            let eps=false
            let ccf=false
            let afp=false
            let valueEpsIngreso= 0
            let valueCcfIngreso=0
            let valueAfpIngreso=0      
            let valueRiesgoIngreso=0
            let valueAdminIngreso=0
            let valueEpsRetiro= 0
            let valueCcfRetiro=0
            let valueAfpRetiro=0      
            let valueRiesgoRetiro=0
            let valueAdminRetiro=0  
            let aflEps= 0
            let aflCcf=0
            let aflAfp=0      
            let aflRiesgo=0
            let valueEps= 0
            let valueCcf=0
            let valueAfp=0      
            let valueRiesgo=0
            let valueAdmin=0  
            let valorServicio=0   
            let indexPrecios=false 
            let salarioDias=parseInt((this.dataForm[this.namePath].info_afiliacion.salario/30)*diasValor)
            if(Object.keys(this.espejoMultiple).length===0)
            {
              for (let i = 0; i < this.predeterminados[this.namePath][this.getTable].length; i++) {
                this.espejoMultiple[this.predeterminados[this.namePath][this.getTable][i].name] = { afiliacion: 0, valor: 0, valoringreso: 0,valorretiro:0}      
              }
            }
            if(this.dataMultiple[this.namePath][this.getTable] && Object.keys(this.espejoMultiple).length>0 && this.dataForm[this.namePath].precios!==undefined)
            {             
              // busco cuantos checks hay activos               
              let riesgo=this.dataMultiple[this.namePath][this.getTable].findIndex(list => { return list.name==='Riesgo'})
              let ultimosCheks=this.dataMultiple[this.namePath][this.getTable].filter(list => list.check===1).length
              //busco el valor del riesgo  en dataMultiple
                let filterRiesgo = this.dataMultiple[this.namePath][this.getTable].filter(list => { return list.name==='Riesgo' && list.check===1})
                if(filterRiesgo.length>0)
                {
                    arlRiesgo=filterRiesgo[0].id_list
                }
              // busco el index de Eps en dataMultiple
                let indexEps = this.dataMultiple[this.namePath][this.getTable].findIndex(list => list.name==='Eps' && list.check)
              // recorro dataMultiple para crear el newDataMultiple

                for (let i = 0; i < this.dataMultiple[this.namePath][this.getTable].length; i++) 
                {  
                  // asignar el subtipo
                    if(this.dataMultiple[this.namePath][this.getTable][i].name==='Afp')
                    {
                      if(this.dataMultiple[this.namePath][this.getTable][i].check===1)
                      {
                        this.updateDataForm({state: 'info_afiliacion/id_list_subtipo', data: 1})
                      }
                      else 
                      {
                        let indexPredeterminado =  _.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': 'info_afiliacion','campo': 'id_list_subtipo', 'id_list_users': this.user.id})

                        if(indexPredeterminado!==-1)
                        {
                          this.updateDataForm({state: 'info_afiliacion/id_list_subtipo' ,data: this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado })
                        }
                      }
                    }
                    if(this.dataMultiple[this.namePath][this.getTable][i].name==='Ccf')
                    {
                      if(this.dataMultiple[this.namePath][this.getTable][i].check===1)
                      {
                        if(this.dataMultiple[this.namePath][this.getTable][i].id_list==20)
                        {
                          this.dataMultiple[this.namePath][this.getTable][i].id_list = _.filter(this.lists.datos_razon, ['id', parseInt(this.dataForm[this.namePath].info_afiliacion.id_datos_razon)])[0].id_list_ccf
                        }                      
                      }
                    }
                  // mirar si el servicio se guardara en newDataMultiple 
                    if(this.hideServicio.findIndex(list => list===this.dataMultiple[this.namePath][this.getTable][i].name)===-1)
                    {
                      // reviso si el servicio debe ser comparado 
                        if(this.comparar!==undefined)
                        {
                          comprarNamecheck = this.comparar.findIndex(list => list.name === this.dataMultiple[this.namePath][this.getTable][i].name)
                        }    
                      // reviso si es de solo lectura o se podra modificar       
                        if(this.readonly && this.dataMultiple[this.namePath][this.getTable][i].check===1)
                        {
                          if(this.dataIndex[this.namePath]===false)
                          {   
                            dataInits=this.deepCopy(this.dataMultiple[this.namePath][this.getTable][i])
                            dataInits.id=null
                            newNewDataMultiple.push(this.deepCopy(dataInits))
                            
                            totalNewValor=totalNewValor+dataInits.valor 
                            totalNewAfiliacion=totalNewAfiliacion+dataInits.afiliacion   
                            /*let indexDataServicios = this.dataForm[this.namePath][this.postTable+'_activos'].findIndex(list => list.name===this.dataMultiple[this.namePath][this.getTable][i].name)
                            let indexDataServicios2 = this.dataForm[this.namePath][this.postTable+'_nuevos'].findIndex(list => list.name===this.dataMultiple[this.namePath][this.getTable][i].name)
                            if(indexDataServicios !== -1)
                            {
                              dataInits=this.deepCopy(this.dataForm[this.namePath][this.postTable+'_activos'][indexDataServicios])
                              dataInits.disabled=this.dataMultiple[this.namePath][this.getTable][i].disabled;
                              newNewDataMultiple.push(this.deepCopy(dataInits)) 
                              // sumo afiliciones y tambien sumo valores
                                totalNewValor=totalNewValor+dataInits.valor 
                                totalNewAfiliacion=totalNewAfiliacion+dataInits.afiliacion 
                            }  
                            else if(indexDataServicios2 !== -1)
                            {
                              dataInits=this.deepCopy(this.dataForm[this.namePath][this.postTable+'_nuevos'][indexDataServicios2])
                              dataInits.disabled=this.dataMultiple[this.namePath][this.getTable][i].disabled;
                              newNewDataMultiple.push(this.deepCopy(dataInits)) 
                              // sumo afiliciones y tambien sumo valores
                                totalNewValor=totalNewValor+dataInits.valor 
                                totalNewAfiliacion=totalNewAfiliacion+dataInits.afiliacion 
                            } */
                          }
                          if(typeof this.dataIndex[this.namePath] ==='number')
                          {
                            if(this.dataForm[this.namePath][this.postTable+'_activos'].find(list => list.name===this.dataMultiple[this.namePath][this.getTable][i].name)!==undefined)
                            {           
                              newNewDataMultiple.push(this.deepCopy(this.dataForm[this.namePath][this.postTable+'_activos'].find(list => list.name===this.dataMultiple[this.namePath][this.getTable][i].name)))          
                            } 
                            else if(this.dataForm[this.namePath][this.postTable+'_inits'].find(list => list.name===this.dataMultiple[this.namePath][this.getTable][i].name)!==undefined)
                            {
                              dataInits=this.dataForm[this.namePath][this.postTable+'_inits'].find(list => list.name===this.dataMultiple[this.namePath][this.getTable][i].name)
                              dataInits.check=0;
                              dataInits.disabled=this.dataMultiple[this.namePath][this.getTable][i].disabled;
                              newNewDataMultiple.push(this.deepCopy(dataInits)) 
                            }    
                            else{ 
                              this.dataMultiple[this.namePath][this.getTable][i].afiliacion=0;
                              this.dataMultiple[this.namePath][this.getTable][i].valor=0;
                              this.dataMultiple[this.namePath][this.getTable][i].valorretiro=0;
                              this.dataMultiple[this.namePath][this.getTable][i].valoringreso=0;
                              newNewDataMultiple.push(this.dataMultiple[this.namePath][this.getTable][i])
                            }         
                          }
                        } 
                      // reviso si se puede modificar
                        if(comprarNamecheck===-1 && this.readonly===false) 
                        {     
                          // cualquier  otra opcion
                            // si esta seleccionado          
                              if(this.dataMultiple[this.namePath][this.getTable][i].check===1)
                              {   
                                let initsIndex=this.dataForm[this.namePath][this.postTable+'_inits'].findIndex(list => {return list.name===this.dataMultiple[this.namePath][this.getTable][i].name})   
                                let nuevosIndex=this.dataForm[this.namePath][this.postTable+'_nuevos'].findIndex(list => {return list.name===this.dataMultiple[this.namePath][this.getTable][i].name})  
                                let activosIndex=this.dataForm[this.namePath][this.postTable+'_activos'].findIndex(list => {return list.name===this.dataMultiple[this.namePath][this.getTable][i].name})

                                // reviso si el servicio esta en _inits y se va actualizar el valor
                                if( initsIndex !== -1 && this.dataMultiple[this.namePath][this.getTable][i].afiliacion===0 && this.dataMultiple[this.namePath][this.getTable][i].valor===0 )
                                {   
                                    let initsValor=this.deepCopy(this.dataForm[this.namePath][this.postTable+'_inits'][initsIndex])
                                    this.dataMultiple[this.namePath][this.getTable][i].id_list=this.deepCopy(initsValor.id_list)
                                    if(this.dataMultiple[this.namePath][this.getTable][i].name==='Administración')
                                    {
                                      this.dataMultiple[this.namePath][this.getTable][i].valor=this.deepCopy(initsValor.valor)  
                                    }
                                                                    
                                }       
                                // reviso si el servicio esta en _nuevos  y se va actualizar el valor
                                else if( nuevosIndex !== -1 && this.dataMultiple[this.namePath][this.getTable][i].check===1 && this.dataMultiple[this.namePath][this.getTable][i].afiliacion===0 && this.dataMultiple[this.namePath][this.getTable][i].valor===0)
                                {                  
                                  if(this.totalValor===0 && this.ultimosCheks===1)
                                  {
                                    let nuevosValor=this.deepCopy(this.dataForm[this.namePath][this.postTable+'_nuevos'][nuevosIndex])
                
                                    this.$set(this.dataMultiple[this.namePath][this.getTable],i,nuevosValor)

                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].afiliacion= this.dataMultiple[this.namePath][this.getTable][i].afiliacion
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valor=this.dataMultiple[this.namePath][this.getTable][i].valor
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valoringreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valorretiro=this.dataMultiple[this.namePath][this.getTable][i].valorretiro  
                                  }
                                  else{
                                    this.dataMultiple[this.namePath][this.getTable][i].id_list=this.deepCopy(this.dataForm[this.namePath][this.postTable+'_nuevos'][nuevosIndex].id_list)
                                  }                                                  
                                }     
                                // reviso si el servicio esta en _activos  y se va actualizar el valor
                                else if(activosIndex !== -1 && this.dataMultiple[this.namePath][this.getTable][i].afiliacion===0 && this.dataMultiple[this.namePath][this.getTable][i].valor===0 )//&& this.ultimoChek===0
                                { 
                                  if(this.totalValor===0  && this.ultimosCheks===1)
                                  {
                                    let activosValor=this.deepCopy(this.dataForm[this.namePath][this.postTable+'_activos'][activosIndex])
                                    
                                    this.$set(this.dataMultiple[this.namePath][this.getTable],i,activosValor)

                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].afiliacion=this.dataMultiple[this.namePath][this.getTable][i].afiliacion
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valor=this.dataMultiple[this.namePath][this.getTable][i].valor 
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valoringreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso 
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valorretiro=this.dataMultiple[this.namePath][this.getTable][i].valorretiro 
                                    this.totalActivos=this.totalActivos+this.dataForm[this.namePath][this.postTable+'_activos'][activosIndex].valor
                                  }  
                                  else{
                                    this.dataMultiple[this.namePath][this.getTable][i].id_list=this.deepCopy(this.dataForm[this.namePath][this.postTable+'_activos'][activosIndex].id_list)
                                  }                           
                                
                                }                                                           
                                // asignar el periodo de aporte
                                  if(this.dataMultiple[this.namePath][this.getTable][i].name!=='Administración' && this.dataMultiple[this.namePath][this.getTable][i].mes_periodo===null && this.dataMultiple[this.namePath][this.getTable][i].ano_periodo===null && this.dataForm[this.namePath].datos_afiliado!==undefined && this.dataForm[this.namePath].datos_afiliado.id!==null)
                                  {
                                    this.dataMultiple[this.namePath][this.getTable][i].mes_periodo=this.dataForm[this.namePath].info_afiliacion.mes_periodo
                                    this.dataMultiple[this.namePath][this.getTable][i].ano_periodo=this.dataForm[this.namePath].info_afiliacion.ano_periodo
                                  }
                                // si es cualquier otro servicio
                                  if(this.dataMultiple[this.namePath][this.getTable][i].name!=='Administración' && this.dataMultiple[this.namePath][this.getTable][i].name!=='Eps' && this.dataMultiple[this.namePath][this.getTable][i].name!=='Riesgo' && this.dataMultiple[this.namePath][this.getTable][i].name!=='Ccf' && this.dataMultiple[this.namePath][this.getTable][i].name!=='Afp')
                                  {
                                    if(this.dataMultiple[this.namePath][this.getTable][i].afiliacion===0 && this.dataMultiple[this.namePath][this.getTable][i].afiliacion===this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].afiliacion && this.ultimoChek!==ultimosCheks)
                                    {
                                      
                                      this.dataMultiple[this.namePath][this.getTable][i].afiliacion=this.deepCopy(this.preciosMultiple[i].afiliacion)
                                    }
                                    if(this.dataMultiple[this.namePath][this.getTable][i].valor===0 && this.dataMultiple[this.namePath][this.getTable][i].valor===this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valor && this.ultimoChek!==ultimosCheks)
                                    {
                                      this.dataMultiple[this.namePath][this.getTable][i].valoringreso=this.deepCopy(this.preciosMultiple[i].valor)
                                      this.dataMultiple[this.namePath][this.getTable][i].valor=this.deepCopy(this.preciosMultiple[i].valor)
                                      this.dataMultiple[this.namePath][this.getTable][i].valorretiro=this.deepCopy(this.preciosMultiple[i].valor)
                                    }
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].afiliacion=this.deepCopy(this.dataMultiple[this.namePath][this.getTable][i].afiliacion)
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valoringreso=this.deepCopy(this.dataMultiple[this.namePath][this.getTable][i].valor)
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valor=this.deepCopy(this.dataMultiple[this.namePath][this.getTable][i].valor)
                                    this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valorretiro=this.deepCopy(this.dataMultiple[this.namePath][this.getTable][i].valor)
                                  }
                                  else{  
                                    indexPrecios=this.dataForm[this.namePath].precios.findIndex(list => { return list.id_list_riesgo.toString()===arlRiesgo.toString() && list.exonerado.toString()===this.dataForm[this.namePath].info_afiliacion.exonerado.toString()})

                                    //si es EPS                    
                                      if(this.dataMultiple[this.namePath][this.getTable][i].name==='Eps')
                                      {
                                        eps=true                      
                                        if(this.dataForm[this.namePath].info_afiliacion.exonerado===1)
                                        {                                        
                                          this.dataMultiple[this.namePath][this.getTable][i].valor=this.redondeaValue(100,parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].epsexo/100),1)+parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].epsexo/100)

                                          if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
                                          {
                                            this.dataMultiple[this.namePath][this.getTable][i].valoringreso=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsexo/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsexo/100)
                                          }
                                          
                                          if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
                                          {
                                            this.dataMultiple[this.namePath][this.getTable][i].valorretiro=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsexo/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsexo/100)
                                          }                                       
                                          
                                        }
                                        else 
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valor=this.redondeaValue(100,parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].epsnoexo/100),1)+parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].epsnoexo/100)
                                          
                                          if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
                                          {
                                            this.dataMultiple[this.namePath][this.getTable][i].valoringreso=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsnoexo/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsnoexo/100)
                                          }
                                          
                                          if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
                                          {
                                            this.dataMultiple[this.namePath][this.getTable][i].valorretiro=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsnoexo/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].epsnoexo/100)
                                          }  
                                        } 
                                        valueEps=this.dataMultiple[this.namePath][this.getTable][i].valor
                                        valueEpsIngreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso
                                        valueEpsRetiro=this.dataMultiple[this.namePath][this.getTable][i].valorretiro
                                        if(this.dataForm[this.namePath].base[0].afiliacion===1)
                                        {
                                          aflEps=this.dataForm[this.namePath].precios[indexPrecios].afleps
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===2)
                                        {
                                          aflEps=valueEps
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===3)
                                        {
                                          aflEps=valueEpsIngreso
                                        }  
                                        let trasladoIndex=this.dataForm[this.namePath][this.postTable+'_activos'].findIndex(list => {return list.name==='Traslado' && list.mes_periodo<=this.dataMultiple[this.namePath][this.getTable][i].mes_periodo && list.ano_periodo<=this.dataMultiple[this.namePath][this.getTable][i].ano_periodo})
                                        if(trasladoIndex!==-1)
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].id_list=this.dataForm[this.namePath][this.postTable+'_activos'][trasladoIndex].id_list
                                        }
                                      }     
                                    //si es RIESGO          
                                      if(this.dataMultiple[this.namePath][this.getTable][i].name==='Riesgo')
                                      {                                      
                                        riesgo=i                  
                                        this.dataMultiple[this.namePath][this.getTable][i].valor=this.redondeaValue(100,parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0]['r'+arlRiesgo]/100),1)+parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0]['r'+arlRiesgo]/100)
                                        
                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valoringreso=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0]['r'+arlRiesgo]/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0]['r'+arlRiesgo]/100)
                                        }
                                        
                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valorretiro=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0]['r'+arlRiesgo]/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0]['r'+arlRiesgo]/100)
                                        } 
                                        valueRiesgo=this.dataMultiple[this.namePath][this.getTable][i].valor
                                        valueRiesgoIngreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso
                                        valueRiesgoRetiro=this.dataMultiple[this.namePath][this.getTable][i].valorretiro

                                        if(this.dataForm[this.namePath].base[0].afiliacion===1)
                                        {
                                          aflRiesgo=0
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===2)
                                        {
                                          aflRiesgo=valueRiesgo
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===3)
                                        {
                                          aflRiesgo=valueRiesgoIngreso
                                        }          
                                      }                                    
                                    //si es CCF   
                                      if(this.dataMultiple[this.namePath][this.getTable][i].name==='Ccf')
                                      {
                                        ccf=true
                                        this.dataMultiple[this.namePath][this.getTable][i].valor=this.redondeaValue(100,parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].ccf/100),1)+parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].ccf/100)

                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valoringreso=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].ccf/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].ccf/100)
                                        }
                                        
                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valorretiro=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].ccf/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].ccf/100)
                                        }      
                                        valueCcf=this.dataMultiple[this.namePath][this.getTable][i].valor
                                        valueCcfIngreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso 
                                        valueCcfRetiro=this.dataMultiple[this.namePath][this.getTable][i].valorretiro 

                                        if(this.dataForm[this.namePath].base[0].afiliacion===1)
                                        {
                                          aflCcf=this.dataForm[this.namePath].precios[indexPrecios].aflccf
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===2)
                                        {
                                          aflCcf=valueCcf
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===3)
                                        {
                                          aflCcf=valueCcfIngreso
                                        }   
                                      }
                                      
                                        
                                    //si es AFP   
                                      if(this.dataMultiple[this.namePath][this.getTable][i].name==='Afp')
                                      {
                                        afp=true
                                        this.dataMultiple[this.namePath][this.getTable][i].valor=this.redondeaValue(100,parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].afp/100),1) +parseInt(this.dataForm[this.namePath].info_afiliacion.salario*this.dataForm[this.namePath].base[0].afp/100)
                                        
                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valoringreso=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].afp/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].afp/100)
                                        }
                                        
                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valorretiro=this.redondeaValue(100,  parseInt(salarioDias*this.dataForm[this.namePath].base[0].afp/100),1)+parseInt(salarioDias*this.dataForm[this.namePath].base[0].afp/100)
                                        }  
                                        valueAfp=this.dataMultiple[this.namePath][this.getTable][i].valor
                                        valueAfpIngreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso 
                                        valueAfpRetiro=this.dataMultiple[this.namePath][this.getTable][i].valorretiro 

                                        if(this.dataForm[this.namePath].base[0].afiliacion===1)
                                        {
                                          aflAfp=this.dataForm[this.namePath].precios[indexPrecios].aflafp
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===2)
                                        {
                                          aflAfp=valueAfp
                                        }
                                        else if(this.dataForm[this.namePath].base[0].afiliacion===3)
                                        {
                                          aflAfp=valueAfpIngreso
                                        }      
                                      }
                                    //si es administracion
                                      if(this.dataMultiple[this.namePath][this.getTable][i].name==='Administración' && ultimosCheks>1)
                                      {                 
                                        indexPrecios=this.dataForm[this.namePath].precios.findIndex(list => { return list.id_list_riesgo.toString()===arlRiesgo.toString() && list.exonerado.toString()===this.dataForm[this.namePath].info_afiliacion.exonerado.toString()}) 
                                        
                                        let indexAdminActivo = _.filter(this.dataForm[this.namePath].servicios_activos,['name','Administración'])

                                        // si es nuevo cambio la admin del valor de cotizacion
                                        if((this.dataForm[this.namePath].datos_afiliado.id===null || this.dataForm[this.namePath].datos_afiliado.id==='') || indexAdminActivo.length===0)  
                                        {                                          
                                          if(
                                            (this.dataForm[this.namePath].precios[indexPrecios].epsarl===this.dataMultiple[this.namePath][this.getTable][i].valor || this.dataForm[this.namePath].precios[indexPrecios].epsarlccf===this.dataMultiple[this.namePath][this.getTable][i].valor || this.dataForm[this.namePath].precios[indexPrecios].epsarlafp===this.dataMultiple[this.namePath][this.getTable][i].valor || this.dataForm[this.namePath].precios[indexPrecios].epsarlccfafp===this.dataMultiple[this.namePath][this.getTable][i].valor) || (this.ultimoRiesgo!==this.dataMultiple[this.namePath][this.getTable][riesgo].id_list) || (ultimosCheks!==this.ultimoChek))
                                          { 
                                            if(eps && ultimosCheks!==this.ultimoChek && !ccf && !afp)
                                            {
                                                this.dataMultiple[this.namePath][this.getTable][i].valor=this.dataForm[this.namePath].precios[indexPrecios].epsarl 
                                            }
                                            else if(eps && !ccf && !afp) 
                                            { 
                                                this.dataMultiple[this.namePath][this.getTable][i].valor=this.dataForm[this.namePath].precios[indexPrecios].epsarl 
                                            }
                                            if(eps && ccf && !afp)
                                            {   
                                              this.dataMultiple[this.namePath][this.getTable][i].valor=this.dataForm[this.namePath].precios[indexPrecios].epsarlccf
                                            } 
                                            if(eps && !ccf && afp)
                                            {
                                              this.dataMultiple[this.namePath][this.getTable][i].valor=this.dataForm[this.namePath].precios[indexPrecios].epsarlafp 
                                            }                                            
                                            if(eps && ccf && afp)
                                            {
                                              this.dataMultiple[this.namePath][this.getTable][i].valor=this.dataForm[this.namePath].precios[indexPrecios].epsarlccfafp
                                            }      
                                          }
                                        }
                                        
                                        if((this.dataForm[this.namePath].info_afiliacion.id_list_novedad===2 && indexAdminActivo.length>0) || ((this.dataForm[this.namePath].datos_afiliado.id!==null && this.namePath==='informes_afiliaciones') || (this.dataForm[this.namePath].datos_afiliado.id!==null && this.namePath==='afiliado_ficha') && indexAdminActivo.length>0))
                                        {  
                                          if((this.ultimoRiesgo!==this.dataMultiple[this.namePath][this.getTable][riesgo].id_list) || (ultimosCheks!==this.ultimoChek) || this.diasValorUltime!==diasValor)
                                          {  
                                            let sobrante2=this.redondeaValue(1000,indexAdminActivo[0].valor,1,1)
                                            if(sobrante2>0)
                                            {
                                              sobrante2=indexAdminActivo[0].valor+sobrante2-1000  
                                            }   
                                            else 
                                            {
                                              sobrante2=indexAdminActivo[0].valor  
                                            }                                         
                                            let sobrante3=this.redondeaValue(1000,valueEps+valueRiesgo+valueCcf+valueAfp+sobrante2,1,1)
                                            this.dataMultiple[this.namePath][this.getTable][i].valor=sobrante2+sobrante3
                                          }                         
                                        } 

                                        // si es novedad 1 modifico el valor del admin dependiendo del tipo de admin ingreso
                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
                                        {                                                                          
                                          if( ((this.ultimoRiesgo!==this.dataMultiple[this.namePath][this.getTable][riesgo].id_list) || (ultimosCheks!==this.ultimoChek)) && this.namePath=='afiliacion_nueva'){   
                                            if((this.dataForm[this.namePath].datos_afiliado.id===null || this.dataForm[this.namePath].datos_afiliado.id==='')  || this.diasValorUltime!==diasValor
                                            )
                                            {  
                                              // proporcional                                            
                                                if(this.dataForm[this.namePath].base[0].proporcional===1)
                                                {   
                                                  let sobranteccfafp = this.redondeaValue(1000,valueEps+valueRiesgo+valueAfp+valueCcf+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1)                                             
                                                  valueAdminIngreso=(valueEps+valueRiesgo+valueAfp+valueCcf+this.dataMultiple[this.namePath][this.getTable][i].valor)-valueEpsIngreso-valueRiesgoIngreso-valueCcfIngreso-valueAfpIngreso+sobranteccfafp
                                                }                                         
                                                if(this.dataForm[this.namePath].base[0].proporcional===2)
                                                {
                                                  let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueCcfIngreso+valueAfpIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                  valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                }    
                                                if(this.dataForm[this.namePath].base[0].proporcional===3)
                                                {
                                                  let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor),1,1) 
                                                  valueAdminIngreso=parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor)+sobranteccfafp
                                                }
                                                if(this.dataForm[this.namePath].base[0].proporcional===4)
                                                {
                                                  if(diasValor<15)
                                                  {
                                                    if(this.dataForm[this.namePath].base[0].menos<this.dataMultiple[this.namePath][this.getTable][i].valor)
                                                    {
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataForm[this.namePath].base[0].menos,1,1) 
                                                      valueAdminIngreso=this.dataForm[this.namePath].base[0].menos+sobranteccfafp
                                                    }
                                                    else 
                                                    {                                      
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                      valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                    }
                                                  }
                                                  if(diasValor>14 && diasValor<26)
                                                  {
                                                    if(this.dataForm[this.namePath].base[0].mas<this.dataMultiple[this.namePath][this.getTable][i].valor)
                                                    {
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataForm[this.namePath].base[0].mas,1,1) 
                                                      valueAdminIngreso=this.dataForm[this.namePath].base[0].mas+sobranteccfafp
                                                    }
                                                    else 
                                                    {                                      
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                      valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                    }
                                                  }
                                                  if(diasValor>25 && diasValor<=30)
                                                  {                                                  
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                      valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                  }
                                                }  
                                                
                                            }  
                                          }
                                          // si el admin fue modificado de manera manual
                                          else if(this.namePath=='afiliacion_nueva')
                                          {                                
                                            valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso
                                          } else {  
                                            
                                            if(((this.ultimoRiesgo!==this.dataMultiple[this.namePath][this.getTable][riesgo].id_list) || (ultimosCheks!==this.ultimoChek) || (this.dataForm[this.namePath].datos_afiliado.id===null || this.dataForm[this.namePath].datos_afiliado.id==='')  || this.diasValorUltime!==diasValor ) && this.namePath!=='aportes_registrar' && this.namePath!=='aportes_cuentas'
                                            )
                                            {  
                                              // proporcional                                            
                                                if(this.dataForm[this.namePath].base[0].proporcional===1)
                                                {   
                                                  let sobranteccfafp = this.redondeaValue(1000,valueEps+valueRiesgo+valueAfp+valueCcf+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1)                                             
                                                  valueAdminIngreso=(valueEps+valueRiesgo+valueAfp+valueCcf+this.dataMultiple[this.namePath][this.getTable][i].valor)-valueEpsIngreso-valueRiesgoIngreso-valueCcfIngreso-valueAfpIngreso+sobranteccfafp
                                                }                                         
                                                if(this.dataForm[this.namePath].base[0].proporcional===2)
                                                {
                                                  let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueCcfIngreso+valueAfpIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                  valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                }    
                                                if(this.dataForm[this.namePath].base[0].proporcional===3)
                                                {
                                                  let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor),1,1) 
                                                  valueAdminIngreso=parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor)+sobranteccfafp
                                                }
                                                if(this.dataForm[this.namePath].base[0].proporcional===4)
                                                {
                                                  if(diasValor<15)
                                                  {
                                                    if(this.dataForm[this.namePath].base[0].menos<this.dataMultiple[this.namePath][this.getTable][i].valor)
                                                    {
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataForm[this.namePath].base[0].menos,1,1) 
                                                      valueAdminIngreso=this.dataForm[this.namePath].base[0].menos+sobranteccfafp
                                                    }
                                                    else 
                                                    {                                      
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                      valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                    }
                                                  }
                                                  if(diasValor>14 && diasValor<26)
                                                  {
                                                    if(this.dataForm[this.namePath].base[0].mas<this.dataMultiple[this.namePath][this.getTable][i].valor)
                                                    {
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataForm[this.namePath].base[0].mas,1,1) 
                                                      valueAdminIngreso=this.dataForm[this.namePath].base[0].mas+sobranteccfafp
                                                    }
                                                    else 
                                                    {                                      
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                      valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                    }
                                                  }
                                                  if(diasValor>25 && diasValor<=30)
                                                  {                                                  
                                                      let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                      valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                  }
                                                }  
                                                
                                            }else 
                                            {   
                                              valueAdminIngreso=this.dataMultiple[this.namePath][this.getTable][i].valoringreso
                                            }
                                          }
                                          this.dataMultiple[this.namePath][this.getTable][i].valoringreso=valueAdminIngreso
                                          this.ultimoAdminIngreso=valueAdminIngreso
                                        }                                         

                                        if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
                                        {
                                          if(this.dataMultiple[this.namePath][this.getTable][i].valorretiro===0 && ((this.ultimoRiesgo!==this.dataMultiple[this.namePath][this.getTable][riesgo].id_list) || (ultimosCheks!==this.ultimoChek) || this.diasValorUltime!==diasValor))
                                          {                                
                                            // proporcional                                  
                                              if(this.dataForm[this.namePath].base[0].proporcional===1)
                                              {    
                                                let sobranteccfafp = this.redondeaValue(1000,valueEps+valueRiesgo+valueAfp+valueCcf+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1)
                                                valueAdminRetiro=(valueEps+valueRiesgo+valueAfp+valueCcf+this.dataMultiple[this.namePath][this.getTable][i].valor)-valueEpsIngreso-valueRiesgoIngreso-valueCcfIngreso-valueAfpIngreso+sobranteccfafp
                                              }                                         
                                              if(this.dataForm[this.namePath].base[0].proporcional===2)
                                              {
                                                let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueCcfIngreso+valueAfpIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                valueAdminRetiro=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                              }    
                                              if(this.dataForm[this.namePath].base[0].proporcional===3)
                                              {
                                                let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor),1,1) 
                                                valueAdminRetiro=parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor)+sobranteccfafp
                                              }
                                              if(this.dataForm[this.namePath].base[0].proporcional===4)
                                              {
                                                if(diasValor<15)
                                                {
                                                  if(this.dataForm[this.namePath].base[0].menos<this.dataMultiple[this.namePath][this.getTable][i].valor)
                                                  {
                                                    let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataForm[this.namePath].base[0].menos,1,1) 
                                                    valueAdminRetiro=this.dataForm[this.namePath].base[0].menos+sobranteccfafp
                                                  }
                                                  else 
                                                  {                                      
                                                    let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                    valueAdminRetiro=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                  }
                                                }
                                                if(diasValor>14 && diasValor<26)
                                                {
                                                  if(this.dataForm[this.namePath].base[0].mas<this.dataMultiple[this.namePath][this.getTable][i].valor)
                                                  {
                                                    let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataForm[this.namePath].base[0].mas,1,1) 
                                                    valueAdminRetiro=this.dataForm[this.namePath].base[0].mas+sobranteccfafp
                                                  }
                                                  else 
                                                  {                                      
                                                    let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                    valueAdminRetiro=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                  }
                                                }
                                                if(diasValor>25 && diasValor<=30)
                                                {                                                  
                                                    let sobranteccfafp = this.redondeaValue(1000,valueEpsIngreso+valueRiesgoIngreso+valueAfpIngreso+valueCcfIngreso+this.dataMultiple[this.namePath][this.getTable][i].valor,1,1) 
                                                    valueAdminRetiro=this.dataMultiple[this.namePath][this.getTable][i].valor+sobranteccfafp
                                                }
                                              }                                                                                   
                                          } 
                                          // si el admin fue modificado de manera manual
                                          else 
                                          {
                                            valueAdminRetiro=this.dataMultiple[this.namePath][this.getTable][i].valorretiro
                                          }
                                          this.dataMultiple[this.namePath][this.getTable][i].valorretiro=valueAdminRetiro
                                          this.ultimoAdminRetiro=valueAdminRetiro
                                        }

                                        /*if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3 && ((ultimosCheks!==this.ultimoChek) || (this.ultimoRiesgo!==this.dataMultiple[this.namePath][this.getTable][riesgo].id_list) || this.ultimoAdminRetiro!==this.dataMultiple[this.namePath][this.getTable][i].valorretiro) )
                                        {
                                          this.dataMultiple[this.namePath][this.getTable][i].valorretiro=valueAdminIngreso
                                          this.ultimoAdminRetiro=valueAdminIngreso
                                        }   */
                                        
                                        if(ultimosCheks!==this.ultimoChek || this.ultimoRiesgo!==this.dataMultiple[this.namePath][this.getTable][riesgo].id_list || this.ultimoAdmin!==this.dataMultiple[this.namePath][this.getTable][i].valor && (this.dataForm[this.namePath].datos_afiliado.id===null || this.dataForm[this.namePath].datos_afiliado.id==='') || this.diasValorUltime!==diasValor)
                                        { 
                                          if(this.dataForm[this.namePath].base[0].afiliacion===1)
                                          {
                                            this.dataMultiple[this.namePath][this.getTable][i].afiliacion=aflEps+aflCcf+aflAfp
                                          }
                                          else if(this.dataForm[this.namePath].base[0].afiliacion===2)
                                          {
                                            this.dataMultiple[this.namePath][this.getTable][i].afiliacion=aflEps+aflCcf+aflRiesgo+aflAfp+this.dataMultiple[this.namePath][this.getTable][i].valor
                                          }
                                          else if(this.dataForm[this.namePath].base[0].afiliacion===3)
                                          {
                                            let sobrante = this.redondeaValue(1000,aflEps+aflCcf+aflRiesgo+aflAfp+parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor),1,1)
                                            let adminafiliacion=parseInt((this.dataMultiple[this.namePath][this.getTable][i].valor/30)*diasValor)+sobrante
                                            this.dataMultiple[this.namePath][this.getTable][i].afiliacion=aflEps+aflCcf+aflRiesgo+aflAfp+adminafiliacion
                                          } 
                                          this.ultimoAdmin=this.dataMultiple[this.namePath][this.getTable][i].valor
                                        }
                                      }   
                                      else if(this.dataMultiple[this.namePath][this.getTable][i].name==='Administración')
                                      {                    
                                        if((this.dataIndex[this.namePath]===false || this.dataIndex[this.namePath]===10000) && (this.dataForm[this.namePath].datos_afiliado.id===null || this.dataForm[this.namePath].datos_afiliado.id===''))
                                        {
                                            this.dataMultiple[this.namePath][this.getTable][i].afiliacion=0
                                            this.dataMultiple[this.namePath][this.getTable][i].valor=0
                                            this.dataMultiple[this.namePath][this.getTable][i].valoringreso=0
                                            this.dataMultiple[this.namePath][this.getTable][i].valorretiro=0
                                        }
                                      }                     
                                  } 
                                this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].afiliacion=this.deepCopy(this.dataMultiple[this.namePath][this.getTable][i].afiliacion);
                                this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valor=this.deepCopy(this.dataMultiple[this.namePath][this.getTable][i].valor);
                              }
                              else {
                                this.dataMultiple[this.namePath][this.getTable][i].id=null;
                                this.dataMultiple[this.namePath][this.getTable][i].afiliacion=0;
                                this.dataMultiple[this.namePath][this.getTable][i].valoringreso=0;
                                this.dataMultiple[this.namePath][this.getTable][i].valorretiro=0;
                                this.dataMultiple[this.namePath][this.getTable][i].valor=0;
                                this.dataMultiple[this.namePath][this.getTable][i].mes_periodo=null;
                                this.dataMultiple[this.namePath][this.getTable][i].ano_periodo=null;              
                                this.dataMultiple[this.namePath][this.getTable][i].id_list = _.filter(this.predeterminados[this.namePath][this.getTable], ['name',this.dataMultiple[this.namePath][this.getTable][i].name])[0].id_list;            

                                this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].afiliacion=0;
                                this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valoringreso=0;
                                this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valorretiro=0;
                                this.espejoMultiple[this.dataMultiple[this.namePath][this.getTable][i].name].valor=0;
                              }                          
                            newNewDataMultiple.push(this.dataMultiple[this.namePath][this.getTable][i]) 
                          // sumo afiliciones y tambien sumo valores
                            totalNewValor=totalNewValor+this.dataMultiple[this.namePath][this.getTable][i].valor 
                            totalNewValorIngreso=totalNewValorIngreso+this.dataMultiple[this.namePath][this.getTable][i].valoringreso 
                            totalNewValorRetiro=totalNewValorRetiro+this.dataMultiple[this.namePath][this.getTable][i].valorretiro
                            totalNewAfiliacion=totalNewAfiliacion+this.dataMultiple[this.namePath][this.getTable][i].afiliacion 
                        }
                    } 
                } 
              //actualizo las variables despeus de creado el newDataMultiple
                this.ultimoRiesgo=this.dataMultiple[this.namePath][this.getTable][riesgo].id_list
                this.ultimoChek=this.dataMultiple[this.namePath][this.getTable].filter(list => list.check===1).length
                this.totalValor=totalNewValor
                this.totalValorIngreso=totalNewValorIngreso
                this.totalValorRetiro=totalNewValorRetiro
                this.totalAfiliacion=totalNewAfiliacion
              
            }
            this.diasValorUltime=diasValor
            this.aportesUltime=valueEps+valueCcf+valueAfp+valueRiesgo
          
            return newNewDataMultiple 
                    

        }  catch(e){
          console.log(e)
        }     
      },
      inputInput(input)
      {
        this.$emit('input', input)
      },
      updateInput(update)
      {
        this.$emit('update', update)
      },
      blurInput(blur)
      {
        this.$emit('blur', blur)
      }  ,
      changeInput(change)
      {
        this.$emit('change', change)
      },
      veevalidateSelect(rules,validate,value='')
      {
        if(validate!=='')
        {
          if(['', undefined].indexOf(rules) === -1)
          {
            return false
          }
          return null
        }
        return null
      },
      veevalidateInputs(rules,validate,value='')
      {
        if(validate!=='') 
        {
          if(['', null, undefined].indexOf(rules) === -1)
          {
            return false
          }
          return null
        }
        return null
      } 
  }
}
</script>
<style>
.custom-control-input:focus ~ .custom-control-label::before{
  box-shadow:0 0 0 1.4px rgba(0, 123, 255, 0.25)
}
.table--multiple{
  border-collapse: separate;
  border-spacing: 10px;
}
.table--multiple td
{
  vertical-align: top;
  padding: 4px 3px
}
.table--multiple th
{
  color: #444;
  font-weight: 500;
  padding: 9px 0 0;
  border-bottom: 1px solid rgba(85, 85, 85, .6);
}
.table--multiple .multiselect--disabled .multiselect__tags{
  border:none;
  background: none;
}
.table--multiple .multiselect--disabled .multiselect__select{
  border-color: #aaa transparent transparent transparent;
}
.table--multiple .multiselect--disabled .multiselect__select{
  display: none
}
.table--multiple .multiselect--disabled .multiselect__single{
  font-size: 1rem;
}
.table--multiple .form-control:disabled, .table--multiple .form-control[readonly] {
  background-color: inherit;
  border: none
}
.table--multiple .input-date:disabled {
  background-color: inherit;
  border: none;
  width: 151px
}
.multiselect.border-danger .multiselect__tags
{
  border-color: #dc3545 !important;
}

.multiselect--active.open-width .multiselect__content-wrapper
{
  min-width: 180px;
}
.multipleMovile{
  zoom: 0.7;
  overflow-x:scroll;
}
       
</style>